import {
  Avatar,
  Button,
  Card,
  CardHeader,
  CardBody,
  Link,
} from '@heroui/react';
import { Icon } from '@iconify/react';
import { useTranslation } from 'react-i18next';

interface EndSurveyCardProps {
  endSurveyCompleted: boolean;
  endSurveyId: number;
}

export function EndSurveyCard({
  endSurveyCompleted,
  endSurveyId,
}: EndSurveyCardProps) {
  const { t } = useTranslation('home');

  if (endSurveyCompleted) return null;

  return (
    <Card className="bg-primary-100" radius="sm" shadow="sm">
      <CardHeader className="flex gap-4 pb-0">
        <Avatar
          color="primary"
          icon={
            <Icon icon="mdi:hand-heart" className="text-3xl text-background" />
          }
          size="md"
        />
        <div className="font-semibold flex flex-col">
          <h2 className="">{t('endsurveycard.title')}</h2>
        </div>
      </CardHeader>
      <CardBody>
        <p>{t('endsurveycard.description')}</p>
        <Button
          as={Link}
          href={`/tracker/${endSurveyId}`}
          className="mt-4 place-self-end"
          color="primary"
        >
          {t('common.button.survey_start')}
        </Button>
      </CardBody>
    </Card>
  );
}
